import { baseFetch } from 'src/utils';

export const getOrgUsersCount = async () => {
  const res = await baseFetch('/api/org/users/count', {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch org users count and domains');
  }

  const data = await res.json();

  return data as { usersCount: number };
};
